import React, { FC } from "react";
import { KpiPersonal } from "../../../Core/Api/Types/get-workflow-user-tasks-kpi-response";
import { GridColDef } from "@mui/x-data-grid";
import DataTable, { CellSize } from "../table";
import { Box, Typography } from "@mui/material";
import { timespanToSec } from "../../../Pages/admin/Dashboard/KpiWorkflow/kpi-workflow";
import { useTranslation } from "react-i18next";
var moment = require("moment");
require("moment-duration-format");

interface KpiWorkflowTableProps {
    rows: KpiPersonal[];
    selectedRow: number | undefined;
    setSelectedRow: (rowId: number) => void;
    minimize: boolean;
}

const KpiWorkflowTable: FC<KpiWorkflowTableProps> = (props) => {
    const { t } = useTranslation();
    const { rows, selectedRow, setSelectedRow, minimize } = props;

    type Row = (typeof rows)[number];

    const columns: GridColDef[] = React.useMemo(
        () => [
            {
                field: "userName",
                headerName: t("common:userName"),
                flex: CellSize.small,
                minWidth: CellSize.small,
            },
            {
                field: "counters",
                headerName: t("table:headerName.totalTask"),
                flex: CellSize.small,
                minWidth: CellSize.small,
                valueFormatter: (data: any, row: any) => {
                    let count = 0;
                    if (!data || !data[0]) return 0;

                    data.forEach((x) => (count += x.count));

                    return count;
                },
            },
            {
                field: "averageTaskTime",
                headerName: t("table:headerName.averageTaskTime"),
                valueFormatter: (data: any, row: any) => moment.duration(timespanToSec(data), "seconds").format(),
                flex: CellSize.small,
                minWidth: CellSize.small,
            },
            {
                field: "averageDelayTime",
                headerName: t("table:headerName.averageDelayTime"),
                valueFormatter: (data: any, row: any) => moment.duration(timespanToSec(data), "seconds").format(),
                flex: CellSize.small,
                minWidth: CellSize.small,
            },
            {
                field: "spentTimeTotal",
                headerName: t("table:headerName.spentTotalTime"),
                valueFormatter: (data: any, row: any) => moment.duration(timespanToSec(data), "seconds").format(),
                flex: CellSize.small,
                minWidth: CellSize.small,
            },
        ],
        []
    );

    if (rows.length === 0)
        return (
            <Box display={"flex"} flexDirection={"column"} justifyContent={"center"} alignItems={"center"}>
                <Typography variant="h6">{t("table:kpiWorkflowTable.body.noUserFound")}</Typography>
                <Typography color="text.tier" variant="body2">
                    {t("table:kpiWorkflowTable.body.changeQueryToFindData")}
                </Typography>
            </Box>
        );

    return (
        <DataTable
            noControls
            getRowId={(row: Row) => row.userId!}
            columns={!minimize ? columns : columns.filter((x) => x.field === "userName")}
            rows={rows}
            columnHeaderHeight={!minimize ? 48 : 0}
            rowHeight={36}
            pagination={false}
            selectedRows={selectedRow ? [selectedRow] : undefined}
            onRowClick={(row) => setSelectedRow(parseInt(row.id.toString()))}
        />
    );
};

export default KpiWorkflowTable;
